'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/braintree-dropin-react/~/react/react.js
// module id = 767
// module chunks = 0